// extracted by mini-css-extract-plugin
module.exports = {"registerContainer":"RegisterForm_registerContainer__Bjgwl","caption":"RegisterForm_caption__o_ZiK"};